import {
    // COMMON
    Add, AddBox, AddCircle, Analytics, AnalyticsOutlined, ChevronRight, Clear, Close,
    ArrowBack, ArrowDownward, ArrowDropDown, ArrowDropUp, ArrowForward, ArrowRight,
    CheckCircle, ChevronLeft, KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight,
    KeyboardArrowUp, ArrowUpward, Comment, Delete, DeleteForever, DeleteOutlined,
    DoNotDisturb, Download, DownloadForOffline, DownloadOutlined, Downloading, Edit,
    EditOutlined, RadioButtonChecked, RadioButtonUnchecked, Filter, FilterAltOffRounded,
    FilterAltRounded, ViewList, Cancel, Check, CheckBox, CheckBoxOutlineBlank, OpenInNew,
    Visibility, VisibilityOff, Error, GridView, Info, InsertDriveFile, Remove, RemoveCircle,
    CalendarMonthOutlined, Search, Reply, Block, CenterFocusStrongOutlined, DeviceHub,
    DragIndicator, Folder, KeyboardVoice, PeopleAlt, PortraitOutlined, PortraitRounded,
    RateReview, Segment, Send, SplitscreenRounded, Stop, Subscriptions, SubscriptionsOutlined,
    SupervisedUserCircle, SupervisedUserCircleOutlined, TableRows, ThumbDown, ThumbDownOutlined,
    ThumbUp, ThumbUpOutlined, UploadFile, Videocam, Warning, Wc, ZoomIn, ZoomOut,
    GraphicEqRounded,

    // SIDE DRAWER ICONS
    Api, ApiOutlined, Announcement, AnnouncementOutlined, Dashboard, DashboardOutlined,
    Assignment, AssignmentOutlined, Badge, BadgeOutlined, Category, CategoryOutlined,
    Description, DescriptionOutlined, DeveloperMode, DeveloperModeOutlined, OndemandVideo,
    OndemandVideoOutlined, ManageAccounts, ManageAccountsOutlined, Lock, LockOutlined,
    EmojiPeople, EmojiPeopleOutlined, Settings, SettingsOutlined, QuestionMark,
    QuestionMarkOutlined, Quiz, QuizOutlined, FiberManualRecord, FiberManualRecordOutlined,
    Home, HomeOutlined, Insights, InsightsOutlined, DynamicForm, DynamicFormOutlined,
    Feedback, FeedbackOutlined, NewReleases, NotificationsActiveOutlined, Rule, RuleOutlined,
    School, SchoolOutlined, PsychologyAlt, PsychologyAltOutlined, Replay, QuestionAnswer,
    QuestionAnswerOutlined, VideocamOutlined, ViewColumnOutlined, Terminal, TerminalOutlined,
    ViewQuilt, ViewQuiltOutlined, PlayCircleFilledWhite, PlayCircleFilledWhiteOutlined,
    AutoStories, AutoStoriesOutlined, LiveHelp, LiveHelpOutlined, CoPresentOutlined, CoPresent,


    // VIDEO PLAYER
    Forward10, VolumeDown, VolumeOff, VolumeUp, Pause, PlayArrow, Fullscreen, FullscreenExit,
    Replay10, Logout, SupportAgent, SupportAgentOutlined, DataObject, MeetingRoom, MeetingRoomOutlined,
    PersonRemove, PersonAdd, Login, OpenInFull, PushPin, PushPinOutlined, Code, BugReport, ExpandLess, ExpandMore,
    CancelPresentation, PresentToAll, AccessTime, Groups, FormatClear,
    Publish, MicOff, VideocamOff, MoreVert, EmojiEmotions, Mic, FrontHand, FrontHandOutlined, Checklist,
    AutoFixHigh, FilePresent, PaletteOutlined, DarkMode, LightMode, ComputerOutlined, SwapVertSharp,
    TrendingUp, Sync, Money, Scoreboard, LastPage, Menu, Person, Class, ClassOutlined, CopyAll,
    AdsClick, DomainAdd, UnfoldMore, Archive, Link, SpeakerNotes, CloudUploadOutlined, Group,
    Pets, Whatshot, History, Pending, TipsAndUpdates, FileUpload, TextFields, Movie,
    AccountBalance, AccountTree, AdminPanelSettings, AdminPanelSettingsOutlined, Sort, ArrowOutward,
    Storage, TheaterComedy, TheaterComedyOutlined, Dvr, DvrOutlined, MenuOpenOutlined,
    Campaign, ReportOutlined, Share, Ballot, ChatBubble, CastForEducation, CastForEducationOutlined,
    Cast, CastConnected, Devices, CheckCircleOutlined, Speed, Wifi, Engineering, EngineeringOutlined, EmojiEvents,
    AddCircleOutlineOutlined, Business, StairsOutlined, FormatListBulleted, BugReportOutlined, LinkOff, BrokenImage, PlaylistAdd,
    Notes, LockOpenOutlined, Public, SwitchAccessShortcut, Swipe, Apps, Science, Memory, Stars, BookmarkBorder, Bookmark,
    Bookmarks, PlaylistAddCheckCircleOutlined, LibraryBooksOutlined, LibraryBooks, CollectionsBookmark, CollectionsBookmarkOutlined, Book,
    BookOutlined, Language, LinkedIn, GitHub, LocationSearching, PictureAsPdf, ContactMail, ContactMailOutlined,

} from '@mui/icons-material'

// IMAGES: FILE ICONS
import pngThumb from '../../shared/assets/png-logo.svg'
import jpgThumb from '../../shared/assets/jpg-logo.svg'
import tiffThumb from '../../shared/assets/png-logo.svg'
import pdfThumb from '../../shared/assets/pdf-logo.svg'
import wordThumb from '../../shared/assets/word-logo.svg'
import excelThumb from '../../shared/assets/excel-logo.svg'
import fileThumb from '../../shared/assets/file-logo.svg'
import pptThumb from '../../shared/assets/ppt-logo.svg'
import videoThumb from '../../shared/assets/videofile-logo.svg'


// CONSTS
export const ERPLoginPageURL = 'https://www.acharyaerptech.in/Login'
export const ERP_API_ENDPOINT = 'https://acerp.acharyaerptech.in'
export const ERPDashboardPageURL = 'https://www.acharyaerptech.in/Dashboard'
export const ALIVE_SUPPORT_URL = 'https://support.alive.university'

const iconProps = {
    sx: {
        color: "inherit", fontSize: "inherit"
    }
}

export const Icons = {}
Icons.default = {
    ContactMail: <ContactMail  {...iconProps} />,
    ContactMailOutlined: <ContactMailOutlined  {...iconProps} />,
    PictureAsPdf: <PictureAsPdf  {...iconProps} />,
    LocationSearching: <LocationSearching  {...iconProps} />,
    LinkedIn: <LinkedIn  {...iconProps} />,
    GitHub: <GitHub  {...iconProps} />,
    Language: <Language  {...iconProps} />,
    BookOutlined: <BookOutlined  {...iconProps} />,
    Book: <Book  {...iconProps} />,
    CollectionsBookmarkOutlined: <CollectionsBookmarkOutlined  {...iconProps} />,
    CollectionsBookmark: <CollectionsBookmark  {...iconProps} />,
    LibraryBooksOutlined: <LibraryBooksOutlined  {...iconProps} />,
    LibraryBooks: <LibraryBooks  {...iconProps} />,
    PlaylistAddCheckCircleOutlined: <PlaylistAddCheckCircleOutlined  {...iconProps} />,
    BookmarkBorder: <BookmarkBorder  {...iconProps} />,
    Bookmark: <Bookmark  {...iconProps} />,
    Bookmarks: <Bookmarks  {...iconProps} />,
    Stars: <Stars  {...iconProps} />,
    Memory: <Memory  {...iconProps} />,
    Science: <Science  {...iconProps} />,
    Apps: <Apps  {...iconProps} />,
    Swipe: <Swipe  {...iconProps} />,
    SwitchAccessShortcut: <SwitchAccessShortcut  {...iconProps} />,
    Public: <Public  {...iconProps} />,
    LockOpenOutlined: <LockOpenOutlined  {...iconProps} />,
    Notes: <Notes  {...iconProps} />,
    PlaylistAdd: <PlaylistAdd  {...iconProps} />,
    BrokenImage: <BrokenImage  {...iconProps} />,
    LinkOff: <LinkOff  {...iconProps} />,
    BugReportOutlined: <BugReportOutlined  {...iconProps} />,
    FormatListBulleted: <FormatListBulleted  {...iconProps} />,
    StairsOutlined: <StairsOutlined  {...iconProps} />,
    EmojiEvents: <EmojiEvents  {...iconProps} />,
    SpeedIcon: <Speed  {...iconProps} />,
    Wifi: <Wifi  {...iconProps} />,
    EngineeringOutlined: <EngineeringOutlined  {...iconProps} />,
    Engineering: <Engineering  {...iconProps} />,
    ReportOutlined: <ReportOutlined  {...iconProps} />,
    AnnouncementMic: <Campaign  {...iconProps} />,
    Devices: <Devices {...iconProps} />,
    Stream: <Cast {...iconProps} />,
    Streamimg: <CastConnected {...iconProps} />,
    HybridClasses: <CastForEducation {...iconProps} />,
    HybridClassesOutlined: <CastForEducationOutlined {...iconProps} />,
    ChatBubble: <ChatBubble {...iconProps} />,
    Ballot: <Ballot  {...iconProps} />,
    Share: <Share  {...iconProps} />,
    Storage: <Storage  {...iconProps} />,
    ArrowOutward: <ArrowOutward  {...iconProps} />,
    Sort2: <Sort  {...iconProps} />,
    MenuClose: <MenuOpenOutlined  {...iconProps} />,
    AdminActivity: <Dvr  {...iconProps} />,
    AdminActivityOutlined: <DvrOutlined  {...iconProps} />,
    Impersonation: <TheaterComedy  {...iconProps} />,
    ImpersonationOutlined: <TheaterComedyOutlined  {...iconProps} />,
    ModulePermissions: <AdminPanelSettings  {...iconProps} />,
    ModulePermissionsOutlined: <AdminPanelSettingsOutlined  {...iconProps} />,
    Branches: <AccountTree  {...iconProps} />,
    Building1: <AccountBalance  {...iconProps} />,
    Business: <Business  {...iconProps} />,
    SupervisedUserCircle: <SupervisedUserCircle  {...iconProps} />,
    Movie: <Movie  {...iconProps} />,
    Upload: <FileUpload {...iconProps} />,
    AskAI: <TipsAndUpdates {...iconProps} />,
    Pending: <Pending {...iconProps} />,
    History: <History {...iconProps} />,
    Trending2: <Whatshot {...iconProps} />,
    Simba: <Pets {...iconProps} />,
    People: <Group {...iconProps} />,
    QuizModule: <SpeakerNotes {...iconProps} />,
    CloudUpload: <CloudUploadOutlined {...iconProps} />,
    File: <InsertDriveFile {...iconProps} />,
    Text: <TextFields  {...iconProps} />,
    RemoveFormat: <FormatClear  {...iconProps} />,
    Archive: <Archive {...iconProps} />,
    Link: <Link {...iconProps} />,
    UnfoldMore: <UnfoldMore {...iconProps} />,
    DomailAdd: <DomainAdd {...iconProps} />,
    Click: <AdsClick {...iconProps} />,
    Copy: <CopyAll {...iconProps} />,
    Class: <Class {...iconProps} />,
    ClassOutlined: <ClassOutlined {...iconProps} />,
    User: <Person {...iconProps} />,
    Menu: <Menu {...iconProps} />,
    Last: <LastPage {...iconProps} />,
    ScoreBoard: <Scoreboard {...iconProps} />,
    Money: <Money {...iconProps} />,
    Sync: <Sync {...iconProps} />,
    TrendingUp: <TrendingUp {...iconProps} />,
    Group: <Groups  {...iconProps} />,
    Sort: <SwapVertSharp {...iconProps} />,
    Clock: <AccessTime {...iconProps} />,
    SystemTheme: <ComputerOutlined   {...iconProps} />,
    DarkMode: <DarkMode   {...iconProps} />,
    LightMode: <LightMode   {...iconProps} />,
    PaletteOutlined: <PaletteOutlined  {...iconProps} />,
    FilePresent: <FilePresent {...iconProps} />,
    MoreVert: <MoreVert {...iconProps} />,
    PresentToAll: <PresentToAll {...iconProps} />,
    EmojiEmotions: <EmojiEmotions {...iconProps} />,
    Mic: <Mic {...iconProps} />,
    FrontHand: <FrontHand {...iconProps} />,
    FrontHandOutlined: <FrontHandOutlined {...iconProps} />,
    Checklist: <Checklist {...iconProps} />,
    AutoFixHigh: <AutoFixHigh {...iconProps} />,
    Publish: <Publish {...iconProps} />,
    CancelPresentation: <CancelPresentation {...iconProps} />,
    MicOff: <MicOff {...iconProps} />,
    VideocamOff: <VideocamOff {...iconProps} />,
    OpenInFull: <OpenInFull {...iconProps} />,
    PushPin: <PushPin {...iconProps} />,
    PushPinOutlined: <PushPinOutlined {...iconProps} />,
    PersonAdd: <PersonAdd {...iconProps} />,
    PersonRemove: <PersonRemove {...iconProps} />,
    Login: <Login {...iconProps} />,
    Info: <Info {...iconProps} />,
    MeetingRooms: <MeetingRoom {...iconProps} />,
    MeetingRoomsOutlined: <MeetingRoomOutlined {...iconProps} />,
    CodeLab: <DataObject {...iconProps} />,
    GraphicEqRounded: <GraphicEqRounded {...iconProps} />,
    SupportAgent: <SupportAgent {...iconProps} />,
    SupportAgentOutlined: <SupportAgentOutlined {...iconProps} />,
    Logout: <Logout {...iconProps} />,
    Terminal: <Terminal {...iconProps} />,
    TerminalOutlined: <TerminalOutlined {...iconProps} />,
    ZoomIn: <ZoomIn {...iconProps} />,
    ZoomOut: <ZoomOut {...iconProps} />,
    CenterFocusStrongOutlined: <CenterFocusStrongOutlined {...iconProps} />,
    Announcement: <Announcement {...iconProps} />,
    AnnouncementOutlined: <AnnouncementOutlined {...iconProps} />,
    Replay: <Replay {...iconProps} />,
    CheckboxChecked: <CheckBox {...iconProps} />,
    RadioUnchecked: <RadioButtonUnchecked {...iconProps} />,
    RadioChecked: <RadioButtonChecked {...iconProps} />,
    PsychologyAlt: <PsychologyAlt {...iconProps} />,
    PsychologyAltOutlined: <PsychologyAltOutlined {...iconProps} />,
    TemporaryUsersOutlined: <SupervisedUserCircleOutlined {...iconProps} />,
    TemporaryUsers: <SupervisedUserCircle {...iconProps} />,
    Books: <Class {...iconProps} />,
    Calendar: <CalendarMonthOutlined {...iconProps} />,
    NotificationsOutlined: <NotificationsActiveOutlined {...iconProps} />,
    ArrowForward: <ArrowForward {...iconProps} />,
    ManageAccounts: <ManageAccounts {...iconProps} />,
    ManageAccountsOutlined: <ManageAccountsOutlined {...iconProps} />,
    Entity: <Category {...iconProps} />,
    EntityOutlined: <CategoryOutlined {...iconProps} />,
    Templates: <ViewQuilt {...iconProps} />,
    TemplatesOutlined: <ViewQuiltOutlined {...iconProps} />,
    Form: <DynamicForm {...iconProps} />,
    FormOutlined: <DynamicFormOutlined {...iconProps} />,
    Api: <Api {...iconProps} />,
    ApiOutlined: <ApiOutlined {...iconProps} />,
    Auditor: <SupervisedUserCircle {...iconProps} />,
    AuditorOutlined: <SupervisedUserCircleOutlined {...iconProps} />,
    Rule: <Rule {...iconProps} />,
    RuleOutlined: <RuleOutlined {...iconProps} />,
    KeyBoardArrowRight: <KeyboardArrowRight {...iconProps} />,
    KeyBoardArrowLeft: <KeyboardArrowLeft {...iconProps} />,
    ArrowRight: <ArrowRight {...iconProps} />,
    Dashboard: <Dashboard {...iconProps} />,
    DashboardOutlined: <DashboardOutlined {...iconProps} />,
    Subjects: <AutoStories {...iconProps} />,
    SubjectsOutlined: <AutoStoriesOutlined {...iconProps} />,
    Course: <CoPresent {...iconProps} />,
    CourseOutlined: <CoPresentOutlined {...iconProps} />,
    Subscriptions: <Subscriptions {...iconProps} />,
    SubscriptionsOutlined: <SubscriptionsOutlined {...iconProps} />,
    Badge: <Badge {...iconProps} />,
    BadgeOutlined: <BadgeOutlined {...iconProps} />,
    QuestionMark: <QuestionMark {...iconProps} />,
    QuestionMarkOutlined: <QuestionMarkOutlined {...iconProps} />,
    Discussions: <QuestionAnswer {...iconProps} />,
    DiscussionsOutlined: <QuestionAnswerOutlined {...iconProps} />,
    Category: <CategoryOutlined {...iconProps} />,
    Reply: <Reply {...iconProps} />,
    Like: <ThumbUp {...iconProps} />,
    LikeOutlined: <ThumbUpOutlined {...iconProps} />,
    Unlike: <ThumbDown {...iconProps} />,
    UnlikeOutlined: <ThumbDownOutlined {...iconProps} />,
    DropDown: <ArrowDropDown {...iconProps} />,
    DropUp: <ArrowDropUp {...iconProps} />,
    Send: <Send {...iconProps} />,
    Comment: <Comment {...iconProps} />,
    FilterAlt: <FilterAltRounded {...iconProps} />,
    FilterAltOff: <FilterAltOffRounded {...iconProps} />,
    Warning: <Warning {...iconProps} />,
    Filter: <Filter {...iconProps} />,
    DoNotDisturb: <DoNotDisturb {...iconProps} />,
    School: <School {...iconProps} />,
    SchoolOutlined: <SchoolOutlined {...iconProps} />,
    Stop: <Stop {...iconProps} />,
    AudioRecorder: <KeyboardVoice {...iconProps} />,
    ArrowBack: <ArrowBack {...iconProps} />,
    Checkbox: <CheckBoxOutlineBlank {...iconProps} />,
    Rows: <TableRows {...iconProps} />,
    AddBox: <AddBox {...iconProps} />,
    Settings: <Settings {...iconProps} />,
    SettingsOutlined: <SettingsOutlined {...iconProps} />,
    ArrowDownward: <ArrowDownward {...iconProps} />,
    ArrowUpward: <ArrowUpward {...iconProps} />,
    KeyboardArrowUp: <KeyboardArrowUp {...iconProps} />,
    ViewColumnRounded: <ViewColumnOutlined {...iconProps} />,
    AddCircleOutlined: <AddCircleOutlineOutlined {...iconProps} />,
    AddCircleIcon: <AddCircle {...iconProps} />,
    DragIndicatorIcon: <DragIndicator {...iconProps} />,
    SplitScreen: <SplitscreenRounded {...iconProps} />,
    Protrait: <PortraitRounded {...iconProps} />,
    ProtraitOutlined: <PortraitOutlined {...iconProps} />,
    KeyboardArrowDownIcon: <KeyboardArrowDown {...iconProps} />,
    FullscreenIcon: <Fullscreen {...iconProps} />,
    FullscreenExitIcon: <FullscreenExit {...iconProps} />,
    VolumeOffIcon: <VolumeOff {...iconProps} />,
    VolumeDownIcon: <VolumeDown {...iconProps} />,
    VolumeUpIcon: <VolumeUp {...iconProps} />,
    PlayArrowIcon: <PlayArrow {...iconProps} />,
    PauseIcon: <Pause {...iconProps} />,
    Forward10Icon: <Forward10 {...iconProps} />,
    Replay10Icon: <Replay10 {...iconProps} />,
    InsightsIcon: <Insights {...iconProps} />,
    InsightsIconOutlined: <InsightsOutlined {...iconProps} />,
    GridViewIcon: <GridView {...iconProps} />,
    SegmentView: <Segment {...iconProps} />,
    ViewListIcon: <ViewList {...iconProps} />,
    LiveHelpIcon: <LiveHelp {...iconProps} />,
    LiveHelpIconOutlined: <LiveHelpOutlined {...iconProps} />,
    InsertDriveFileIcon: <InsertDriveFile {...iconProps} />,
    RemoveIcon: <Remove {...iconProps} />,
    DownloadingIcon: <Downloading {...iconProps} />,
    FolderIcon: <Folder {...iconProps} />,
    CheckIcon: <Check {...iconProps} />,
    QuizIcon: <Quiz {...iconProps} />,
    QuizIconOutlined: <QuizOutlined {...iconProps} />,
    RemoveCircleIcon: <RemoveCircle {...iconProps} />,
    NewReleasesIcon: <NewReleases {...iconProps} />,
    PlayCircleFilledWhiteIcon: <PlayCircleFilledWhite {...iconProps} />,
    PlayCircleFilledWhiteIconOutlined: <PlayCircleFilledWhiteOutlined {...iconProps} />,
    FiberManualRecordIcon: <FiberManualRecord {...iconProps} />,
    FiberManualRecordIconOutlined: <FiberManualRecordOutlined {...iconProps} />,
    UploadFileIcon: <UploadFile {...iconProps} />,
    EmojiPeopleIcon: <EmojiPeople {...iconProps} />,
    EmojiPeopleIconOutlined: <EmojiPeopleOutlined {...iconProps} />,
    ErrorIcon: <Error {...iconProps} />,
    ClearIcon: <Clear {...iconProps} />,
    BlockIcon: <Block {...iconProps} />,
    CheckCircleIcon: <CheckCircle {...iconProps} />,
    CheckCircleIconOutlined: <CheckCircleOutlined {...iconProps} />,
    EditIcon: <Edit {...iconProps} />,
    EditIconOutlined: <EditOutlined {...iconProps} />,
    AssignmentIcon: <Assignment {...iconProps} />,
    AssignmentIconOutlined: <AssignmentOutlined {...iconProps} />,
    DescriptionIcon: <Description {...iconProps} />,
    DescriptionIconOutlined: <DescriptionOutlined {...iconProps} />,
    DeviceHubIcon: <DeviceHub {...iconProps} />,
    PeopleAltIcon: <PeopleAlt {...iconProps} />,
    WcIcon: <Wc {...iconProps} />,
    SearchIcon: <Search {...iconProps} />,
    AddIcon: <Add {...iconProps} />,
    CodeIcon: <Code {...iconProps} />,
    BugReportIcon: <BugReport {...iconProps} />,
    ExpandLessIcon: <ExpandLess {...iconProps} />,
    ExpandMoreIcon: <ExpandMore {...iconProps} />,
    ExpandMoreComponent: ExpandMore,
    ExpandMore: ExpandMore,
    RateReviewIcon: <RateReview {...iconProps} />,
    DeleteIcon: <Delete {...iconProps} />,
    DeleteIconOutlined: <DeleteOutlined {...iconProps} />,
    VisibilityIcon: <Visibility {...iconProps} />,
    VisibilityOffIcon: <VisibilityOff {...iconProps} />,
    OndemandVideoIcon: <OndemandVideo {...iconProps} />,
    OndemandVideoIconOutlined: <OndemandVideoOutlined {...iconProps} />,
    FeedbackIcon: <Feedback {...iconProps} />,
    FeedbackIconOutlined: <FeedbackOutlined {...iconProps} />,
    HomeIcon: <Home {...iconProps} />,
    HomeIconOutlined: <HomeOutlined {...iconProps} />,
    DeveloperModeIcon: <DeveloperMode {...iconProps} />,
    DeveloperModeIconOutlined: <DeveloperModeOutlined {...iconProps} />,
    LockIcon: <Lock {...iconProps} />,
    LockIconOutlined: <LockOutlined {...iconProps} />,
    AnalyticsIcon: <Analytics {...iconProps} />,
    AnalyticsIconOutlined: <AnalyticsOutlined {...iconProps} />,
    CloseIcon: <Close {...iconProps} />,
    VideocamIcon: <Videocam {...iconProps} />,
    VideocamIconOutlined: <VideocamOutlined {...iconProps} />,
    ChevronLeftIcon: <ChevronLeft {...iconProps} />,
    ChevronRightIcon: <ChevronRight {...iconProps} />,
    CancelIcon: <Cancel {...iconProps} />,
    DownloadForOfflineIcon: <DownloadForOffline {...iconProps} />,
    DownloadIcon: <Download {...iconProps} />,
    DownloadIconOutlined: <DownloadOutlined {...iconProps} />,
    OpenInNewIcon: <OpenInNew {...iconProps} />,
    DeleteForever: <DeleteForever {...iconProps} />,
}

export const ASSIGNMENT_CONVERT_DUE_TIME_BEFORE = '2026-01-20T18:30:00.000Z'

export const ACHARYA_EMAIL_PATTERN = /(([a-z0-9.]+)@acharya.ac.in)+/

export const SPACES_LOCATION_REGEXP = /(https:\/\/(?<bucket>[a-z-]+)\.)?(?<region>[a-zA-Z0-9]+)\.(cdn\.)?digitaloceanspaces\.com\/(?<key>(?<folder>[a-zA-Z_/-]+)\/(?<filesavedfullname>(\d{10,}\.)?(?<filefullname>[.a-zA-Z0-9@%()_-\s]+\.(?<fileextention>\w+))))\/?/

export const CHIP_COLORS = ['#49982E', '#FF9053', '#353297', '#00ABE4', '#5E2974']
export const EXAM_CARD_COLORS = ['#FFDF8C', '#D6FFA6', '#A7DAFF']

export const FLAT_LIGHT_COLORS = ['#DBFFD4', '#D5F0FF', '#FFE0E4', '#b2dfdb', '#e6ee9c', '#c5e1a5', '#a5d6a7', '#ffcc80', '#ffe082', '#ffccbc']

export const FLAT_COLORS = ['#f7514d', '#1FC439', '#C54097', '#49982E', '#933df5']

export const ALPHABETS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

export const EMPTY_ARRAY = []
export const EMPTY_OBJECT = {}
export const EMPTY_ARROW_FUNCTION = () => { }

export const POLL_OPTIONS_COLORS = [
    "#3498db", // Blue
    "#e67e22", // Orange
    "#2ecc71", // Green
    "#9b59b6", // Purple
    "#f1c40f", // Yellow
    "#1abc9c", // Teal
    "#e74c3c", // Red
    "#34495e", // Dark Blue-gray
    "#fd79a8", // Pink
    "#00cec9", // Cyan
    "#e84393", // Deep Pink
    "#6c5ce7", // Indigo
    "#d35400", // Dark Orange
    "#27ae60", // Emerald
    "#2980b9", // Darker Blue
    "#16a085", // Dark Teal
    "#f39c12", // Yellow Orange
    "#c0392b", // Dark Red
    "#7f8c8d", // Gray
    "#8e44ad", // Dark Purple
]

export const USER_CARD_COLOR_SETS = [
    {
        gradient: "radial-gradient(circle, #692591, #9e2e91)",
        gradientColors: ["#692591", "#9e2e91"],
        primary: "#5902b7",
    },
    {
        gradient: "radial-gradient(circle, #e67151, #e0792a)",
        gradientColors: ["#e67151", "#e0792a"],
        primary: "#d84315",
    },
    {
        gradient: "radial-gradient(circle, #5c2ec4, #2b56d6)",
        gradientColors: ["#5c2ec4", "#2b56d6"],
        primary: "#4527a0",
    },
    {
        gradient: "radial-gradient(circle, #f08a93, #c0374e)",
        gradientColors: ["#f08a93", "#c0374e"],
        primary: "#c2185b",
    },
    {
        gradient: "radial-gradient(circle, #276fa6, #204980)",
        gradientColors: ["#276fa6", "#204980"],
        primary: "#1976d2",
    },
    {
        gradient: "radial-gradient(circle, #802085, #26317b)",
        gradientColors: ["#802085", "#26317b"],
        primary: "#8e24aa",
    },
    {
        gradient: "radial-gradient(circle, #ef943a, #ca5114)",
        gradientColors: ["#ef943a", "#ca5114"],
        primary: "#a34c04",
    },
    {
        gradient: "radial-gradient(circle, #309d84, #00695c)",
        gradientColors: ["#309d84", "#00695c"],
        primary: "#00695c",
    },
    {
        gradient: "radial-gradient(circle, #ce7385, #ad314a)",
        gradientColors: ["#ce7385", "#ad314a"],
        primary: "#ad1457",
    },
    {
        gradient: "radial-gradient(circle, #44c2cf, #362c7a)",
        gradientColors: ["#44c2cf", "#362c7a"],
        primary: "#00838f",
    },
    {
        gradient: "radial-gradient(circle, #f7a93d, #a88512)",
        gradientColors: ["#f7a93d", "#a88512"],
        primary: "#a08912",
    },
    {
        gradient: "radial-gradient(circle, #c54d6f, #403480)",
        gradientColors: ["#c54d6f", "#403480"],
        primary: "#880e4f",
    },
    {
        gradient: "radial-gradient(circle, #c24646, #2d5aa6)",
        gradientColors: ["#c24646", "#2d5aa6"],
        primary: "#8e0000",
    },
    {
        gradient: "radial-gradient(circle, #ff7a26, #c4326f)",
        gradientColors: ["#ff7a26", "#c4326f"],
        primary: "#e64a19",
    },
    {
        gradient: "radial-gradient(circle, #6cb94e, #2e7d32)",
        gradientColors: ["#6cb94e", "#2e7d32"],
        primary: "#2e7d32",
    },
    {
        gradient: "radial-gradient(circle, #6b4e91, #505d87)",
        gradientColors: ["#6b4e91", "#505d87"],
        primary: "#4527a0",
    },
    {
        gradient: "radial-gradient(circle, #32b7b8, #00a89c)",
        gradientColors: ["#32b7b8", "#00a89c"],
        primary: "#00796b",
    },
    {
        gradient: "radial-gradient(circle, #f15d4a, #d93772)",
        gradientColors: ["#f15d4a", "#d93772"],
        primary: "#c62828",
    },
    {
        gradient: "radial-gradient(circle, #29b0f5, #1560d1)",
        gradientColors: ["#29b0f5", "#1560d1"],
        primary: "#1565c0",
    },
    {
        gradient: "radial-gradient(circle, #e5b981, #8d6e63)",
        gradientColors: ["#e5b981", "#8d6e63"],
        primary: "#8d6e63",
    },
]

export const FLAT_COLORS_WITH_BACKGROUND = [
    { bg: '#DAFFD4', color: '#1FC439' },
    { bg: '#FFD9CB', color: '#E25A26' },
    { bg: '#FFEBFF', color: '#5E2974' },
    { bg: '#FFDAFE', color: '#A200E5' },
    { bg: '#FFE3E2', color: '#FF3E39' },
    { bg: '#CCE1EF', color: '#139CFF' },
    { bg: '#FED7FD', color: '#C54097' },
    { bg: '#FFDBCD', color: '#FF7641' },
]

export const FLAT_GRADIENTS = [
    {
        background: 'linear-gradient( 90deg,rgb(56, 90, 239),rgb(63, 87, 160) )',
        color: '#FFFFFF',
    },
    {
        background: 'linear-gradient( 90deg, #db7093, #e57373 )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #882dbd, #9c4dc9 )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #8fbc53, #69a065 )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #1a6d89, #5494bc )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #5f6ec1, #6b7acf )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #d7761c, #e49c59 )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #175289, #3f8cab )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #b58816, #d6a529 )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #5159b8, #604191 )',
        color: '#FFFFFF',
    },

    {
        background: 'linear-gradient( 90deg, #f1bd68, #9bd3e2 )',
        color: '#FFFFFF',
    },
]

export const attachmentThumbnails = {
    png: pngThumb,
    jpg: jpgThumb,
    jpeg: jpgThumb,
    tiff: tiffThumb,
    pdf: pdfThumb,
    docx: wordThumb,
    xls: excelThumb,
    xlsx: excelThumb,
    default: fileThumb,
    pptx: pptThumb,
    mp4: videoThumb,
    wepm: videoThumb,
    ppsx: pptThumb,
}

export const latexDelimiters = [
    { left: '$$', right: '$$', display: true },
    { left: '\\(', right: '\\)', display: false },
    { left: '$', right: '$', display: false },
    { left: '\\[', right: '\\]', display: true },
]

export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday', 'Sunday']
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export const HOURS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
export const DOC_VIEWER_SUPPORTED_FORMATS = ['mp4', 'webm', 'ogg', 'mp3', 'bmp', 'jpg', 'jpeg', 'docx', 'html', 'htm', 'doc', 'pdf', 'png', 'ppt', 'pptx', 'tiff', 'txt', 'xls', 'xlsx']

export const getNameInitials = ( name ) => {
    try {
        const nameParts = name?.split( " " )
        return nameParts.map( n => n?.at( 0 ) ).slice( 0, 2 )
    } catch ( err ) {
        return name?.at( 0 )
    }
}

export const isReactComponent = ( value ) => {
    return (
        typeof value === 'function' ||
        ( value && typeof value === 'object' && value.$$typeof === Symbol.for( 'react.element' ) )
    )
}

export const getGroupChipLabel = groupDetails => {
    if ( groupDetails.entity === 'batch' || groupDetails.batch_assignment_id ) {
        return groupDetails.chip_label || `Batch: ${groupDetails.batch_name}${groupDetails.remarks ? `, ${groupDetails.remarks}` : "Remarks: Not given."}`
    }
    if ( groupDetails.entity === 'section' || groupDetails.section_assignment_id ) {
        return groupDetails.chip_label || `Section: ${groupDetails.section_short_name} `
    }
    return ""
}

export const getTransformedGroupDetails = group => {
    if ( group.entity === 'batch' || group.batch_assignment_id ) {
        const batch = { ...group }
        if ( !batch.course_name_short )
            batch.course_name_short = batch.course_short_name
        batch.id = batch.batch_assignment_id
        batch.entity = 'batch'
        batch.title = `${batch.batch_name}-${batch.course_name_short || ""}${batch.current_year ? ` Y${batch.current_year}` : ``}${batch.current_sem ? ` S${batch.current_sem}` : ``} ${batch.batch_short_name}`
        batch.short_title = `Batch ${batch.batch_name || batch.batch_short_name}${batch.remarks ? `, ${batch.remarks}` : ", Remarks: Not given."}`
        batch.chip_label = `Batch: ${batch.batch_name || batch.batch_short_name}${batch.remarks ? `, ${batch.remarks}` : ", Remarks: Not given."}`
        batch.academic_details = `${batch.ac_year ? `${batch.ac_year},` : ""} ${batch.current_year ? `Year: ${batch.current_year}` : ""}${batch.current_sem ? `, Semester: ${batch.current_sem}` : ""}, Remarks: ${batch.remarks || "Not given."}`
        batch.course_name_short = Array.from( new Set( batch.course_name_short?.split( "," ) ) ).join( ", " )
        return batch
    }
    if ( group.entity === 'section' || group.section_assignment_id ) {
        const section = { ...group }
        section.id = `${section.section_assignment_id}-${section.section_short_name}`
        section.entity = 'section'
        section.title = `${section.course_branch_short_name}-${section.course_short_name || ""}${section.current_year ? ` Y${section.current_year}` : ``}${section.current_sem ? ` S${section.current_sem}` : ``} (${section.section_short_name + ")"}`
        section.short_title = `Section ${section.section_short_name}`
        section.chip_label = `Section: ${section.section_short_name} `
        section.academic_details = `${section.ac_year ? `${section.ac_year},` : ""} ${section.current_year ? `Year: ${section.current_year}` : ""}${section.current_sem ? `, Semester: ${section.current_sem}` : ""}, Remarks: ${section.remarks || "Not given."}`
        section.course_name_short = section.course_short_name
        return section
    }
}

export const leadingZeroFormatter = new Intl.NumberFormat( undefined, {
    minimumIntegerDigits: 2,
} )

export const getKeyValueFromObject = ( obj, keys ) => {
    if ( typeof keys === 'string' ) {
        return obj ? obj[keys] : undefined
    }

    if ( Array.isArray( keys ) ) {
        return keys.reduce( ( acc, key ) => ( acc ? acc[key] : undefined ), obj )
    }

    return undefined
}

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    const isMobileUA = /mobile|android|iphone|ipad|phone/i.test( userAgent )
    const isSmallScreen = window.matchMedia( '(max-width: 767px)' ).matches
    return { isMobile: isMobileUA || typeof window?.orientation !== 'undefined' || navigator.userAgent.indexOf( 'IEMobile' ) !== -1, isSmallScreen }
}

export const getBrowserDetails = () => {
    const userAgent = navigator.userAgent
    const language = navigator.language

    let browserName = 'Unknown'
    let fullVersion = 'Unknown'

    if ( userAgent.indexOf( 'Chrome' ) > -1 ) {
        browserName = 'Chrome'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Chrome' ) + 7 )
    } else if ( userAgent.indexOf( 'Firefox' ) > -1 ) {
        browserName = 'Firefox'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Firefox' ) + 8 )
    } else if ( userAgent.indexOf( 'MSIE' ) > -1 || !!document.documentMode ) {
        browserName = 'Internet Explorer'
        fullVersion = userAgent.substring( userAgent.indexOf( 'MSIE' ) + 5 )
    } else if ( userAgent.indexOf( 'Safari' ) > -1 && userAgent.indexOf( 'Chrome' ) === -1 ) {
        browserName = 'Safari'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Safari' ) + 7 )
    } else if ( userAgent.indexOf( 'Opera' ) > -1 || userAgent.indexOf( 'OPR' ) > -1 ) {
        browserName = 'Opera'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Opera' ) + 6 )
    }

    // Extract only the version number (e.g., "96.0" from "96.0.4664.110")
    const version = fullVersion.split( ' ' )[0].split( '.' )[0]

    return {
        userAgent: userAgent,
        language: language,
        browserName,
        fullVersion,
        version,
    }
}

export const boundaryValue = ( min, desired, max ) => {
    if ( desired == null ) {
        return min
    }
    return Math.max( min, Math.min( desired, max ) )
}

export const convertToCDNLink = ( data = "" ) => {
    if ( typeof data !== 'string' || data.includes( "cdn.digitaloceanspaces" ) )
        return data
    return data?.replace( /digitaloceanspaces/, 'cdn.digitaloceanspaces' )
}

export const replaceSpacesesLocationsWithCDNLinks = ( data ) => {
    if ( typeof data === 'string' ) {
        const regex = /https:\/\/[a-z-]+\.[a-zA-Z0-9]+\.digitaloceanspaces\.com\/(?<key>(?!cdn\/)[a-zA-Z_/-]+\/[.a-zA-Z0-9@%()_-\s]+\.\w+\/?)/gm
        const result = data.replace( regex, ( match ) => {
            return match.replace( '.digitaloceanspaces.com', '.cdn.digitaloceanspaces.com' )
        } )
        return result
    } else return data
}

export const extractSpacesLinkFromText = ( data ) => {
    if ( typeof data === 'string' ) {
        const regex = /https:\/\/(?<bucket>[a-z-]+)\.(?<region>[a-zA-Z0-9]+)\.(cdn\.)?digitaloceanspaces\.com\/(?<key>[a-zA-Z_/-]+\/[.a-zA-Z0-9@%()_-\s]+\.\w+\/?)/gm
        const result = Array.from( data.matchAll( regex ) )
        const matched = result.map( ( r ) => r[0] )
        return { matched, matchedWithGroups: result }
    } else return data
}

export const getUniqueStringFromLongString = ( input ) => {
    input = input + ''
    let hash = 0
    for ( let i = 0; i < input.length; i++ ) {
        hash = ( hash << 5 ) - hash + input.charCodeAt( i )
        hash &= hash // Convert to 32-bit integer
    }
    return Math.abs( hash ).toString( 36 ) // Convert to base-36 for compactness
}

export const getFileSizeFromBytes = ( bytes ) => {
    if ( isNaN( bytes ) ) return '-'
    const kb = bytes / 1024
    if ( kb < 1024 ) return `${kb?.toFixed( 2 )} KB`
    else if ( kb / 1024 < 1024 ) return `${( kb / 1024 )?.toFixed( 2 )} MB`
    else return `${( kb / ( 1024 * 1024 ) )?.toFixed( 2 )} GB`
}

export const getCountString = ( count ) => {
    if ( Number.isNaN( +count ) ) return '_'
    if ( count < 1000 ) return count
    const inKilo = count / 1000
    if ( +inKilo < 1000 ) {
        const [whole, decimal = '0'] = ( '' + inKilo ).split( '.' )
        return `${whole}.${decimal[0]}K+`
    }
    const inMil = ( +inKilo / 1000 ).toFixed( 1 )
    const [whole, decimal = '0'] = ( '' + inMil ).split( '.' )
    return `${whole}.${decimal[0]}M+`
}

const createImage = ( url ) =>
    new Promise( ( resolve, reject ) => {
        const image = new Image()
        image.addEventListener( 'load', () => resolve( image ) )
        image.addEventListener( 'error', ( error ) => reject( error ) )
        image.setAttribute( 'crossOrigin', 'anonymous' ) // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    } )

export const getCroppedImage = async ( imageSrc, pixelCrop ) => {
    const image = await createImage( imageSrc )
    const canvas = document.createElement( 'canvas' )
    const ctx = canvas.getContext( '2d' )

    if ( !ctx ) {
        return null
    }

    const { width: bBoxWidth, height: bBoxHeight } = image

    canvas.width = bBoxWidth
    canvas.height = bBoxHeight

    ctx.translate( bBoxWidth / 2, bBoxHeight / 2 )
    ctx.translate( -image.width / 2, -image.height / 2 )

    ctx.drawImage( image, 0, 0 )

    const data = ctx.getImageData( pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height )

    canvas.width = pixelCrop.width
    canvas.height = pixelCrop.height

    ctx.putImageData( data, 0, 0 )

    return await new Promise( ( resolve, reject ) => {
        canvas.toBlob( ( file ) => {
            file.name = 'cropped.jpeg'
            resolve( { file: file, url: URL.createObjectURL( file ) } )
        }, 'image/jpeg' )
    } )
}

export const base64ToFileAndBlob = async ( base64String, fileName, mimeType ) => {
    const byteCharacters = atob( base64String.split( ',' )[1] )

    const byteArray = new Uint8Array( byteCharacters.length )

    for ( let i = 0; i < byteCharacters.length; i++ ) {
        byteArray[i] = byteCharacters.charCodeAt( i )
    }

    const blob = new Blob( [byteArray], { type: mimeType } )

    const file = new File( [blob], fileName, { type: mimeType } )

    return { file, blob }
}

export const extractMimeType = ( base64String ) => {
    const regex = /^data:(image|video|audio|application|text|font)\/([a-zA-Z0-9-+.]+);base64,/
    const match = base64String.match( regex )

    if ( match ) {
        return match[0]?.split( ':' )[1]?.split( ';' )[0]
    } else {
        console.error( 'Invalid base64 data URL' )
        return null
    }
}

export const getTimePassedFrom = ( time ) => {
    const now = Date.now()
    const createdTime = new Date( time ).getTime()
    const diff = ( now - createdTime ) / 1000
    if ( diff < 60 ) return 'Few seconds ago'
    else if ( diff < 60 * 60 ) {
        const count = Math.floor( diff / 60 )
        return `${count} minute${count > 1 ? 's' : ''} ago`
    } else if ( diff < 60 * 60 * 24 ) {
        const count = Math.floor( diff / 3600 )
        return `${count} hour${count > 1 ? 's' : ''} ago`
    } else if ( diff < 31536000 ) {
        const count = Math.floor( diff / ( 3600 * 24 ) )
        return `${count} day${count > 1 ? 's' : ''} ago`
    } else {
        const count = Math.floor( diff / 31536000 )
        return `${count} Year${count > 1 ? 's' : ''} ago`
    }
}

export const getExtraSIfPlural = ( count, esPostfix = false ) => {
    return !( !count || count <= 1 ) ? esPostfix ? "es" : "s" : ""
}

export const getTimePassedFromDetails = ( time ) => {
    const now = Date.now()
    const createdTime = new Date( time ).getTime()
    const diff = ( now - createdTime ) / 1000

    let displayString = ""

    if ( diff < 60 ) displayString = 'Few seconds ago'
    else if ( diff < 60 * 60 ) {
        const count = Math.floor( diff / 60 )
        displayString = `${count} minute${count > 1 ? 's' : ''} ago`
    } else if ( diff < 60 * 60 * 24 ) {
        const count = Math.floor( diff / 3600 )
        displayString = `${count} hour${count > 1 ? 's' : ''} ago`
    } else if ( diff < 31536000 ) {
        const count = Math.floor( diff / ( 3600 * 24 ) )
        displayString = `${count} day${count > 1 ? 's' : ''} ago`
    } else {
        const count = Math.floor( diff / 31536000 )
        displayString = `${count} Year${count > 1 ? 's' : ''} ago`
    }

    return {
        displayString,
        diff,
        h: Math.floor( diff / 3600 ),
        m: Math.floor( ( diff % 3600 ) / 60 ),
        s: Math.floor( ( diff % 3600 ) % 60 ),
    }
}

export const shuffleArray = ( array ) => {
    let currentIndex = array.length,
        randomIndex
    while ( currentIndex !== 0 ) {
        randomIndex = Math.floor( Math.random() * currentIndex )
        currentIndex--
            ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
    }

    return array
}

export const mergeArray = ( indexes, arrayList ) => {
    let newArray = []
    for ( let i = 0; i < indexes.length; i++ ) {
        const index = indexes[i]
        newArray = newArray.concat( arrayList[index] )
    }
    return newArray
}

export const formatVideoDuration = ( time ) => {
    const seconds = Math.floor( time % 60 )
    const minutes = Math.floor( time / 60 ) % 60
    const hours = Math.floor( time / 3600 )
    if ( hours === 0 ) {
        return `${minutes}:${leadingZeroFormatter.format( seconds )}`
    } else {
        return `${hours}:${leadingZeroFormatter.format( minutes )}:${leadingZeroFormatter.format( seconds )}`
    }
}

export const secondsToHMS = ( time, showZeroValues = true ) => {
    time = Number( time )
    var h = Math.floor( time / 3600 )
    var m = Math.floor( ( time % 3600 ) / 60 )
    var s = Math.floor( ( time % 3600 ) % 60 )

    if ( showZeroValues )
        return `${leadingZeroFormatter.format( h )}:${leadingZeroFormatter.format( m )}:${leadingZeroFormatter.format( s )}`
    return `${h > 0 ? `${leadingZeroFormatter.format( h )}:` : ""}${leadingZeroFormatter.format( m )}:${leadingZeroFormatter.format( s )}`
}

export function minutesToString ( totalMinutes, options = {} ) {
    if ( typeof totalMinutes !== 'number' || totalMinutes < 0 ) return ''

    const hours = Math.floor( totalMinutes / 60 )
    const minutes = totalMinutes % 60

    const { short = false, tiny = false } = options

    // Define label maps based on flags
    const getLabels = ( value, unit ) => {
        if ( tiny ) {
            return unit === 'hour' ? 'H' : 'M'
        }
        if ( short ) {
            return unit === 'hour' ? 'hr' : 'min'
        }
        // Full labels with pluralization
        const isPlural = value !== 1
        return unit === 'hour'
            ? ( isPlural ? 'Hours' : 'Hour' )
            : ( isPlural ? 'Minutes' : 'Minute' )
    }

    const parts = []

    if ( hours > 0 ) {
        parts.push( `${hours}${tiny ? '' : ' '}${getLabels( hours, 'hour' )}` )
    }

    // Show minutes if present or if total duration is 0
    if ( minutes > 0 || hours === 0 ) {
        parts.push( `${minutes}${tiny ? '' : ' '}${getLabels( minutes, 'minute' )}` )
    }

    return parts.join( ' ' )
}

let debounceTimeoutIds = {}
export const debounce = ( debounceId, func, delay = 500 ) => {
    return ( ...args ) => {
        if ( debounceTimeoutIds[debounceId] ) clearTimeout( debounceTimeoutIds[debounceId] )
        debounceTimeoutIds[debounceId] = setTimeout( () => {
            func.apply( null, args )
        }, delay )
    }
}

export const getMaxValueByKey = ( list, key ) => {
    if ( !Array.isArray( list ) ) throw new Error( `First argument must be an array, reaceived ${typeof list}` )
    return list.reduce( ( max, item ) => ( item[key] > max ? item[key] : max ), 0 )
}

export const sortArrayOfObjectsByKey = ( list, key, order = 1, dataType = "string" ) => {
    if ( dataType === "string" ) {
        const sortedList = [...list]
        sortedList.sort( ( a, b ) => a[key].localeCompare( b[key] ) )
        if ( order === -1 ) sortedList.reverse()
        return sortedList
    } else {
        const sortedList = [...list]
        sortedList.sort( ( a, b ) => a[key] > b[key] ? 1 : -1 )
        if ( order === -1 ) sortedList.reverse()
        return sortedList
    }
}

export const sortByProperty = ( data, setData, property, type, order ) => {
    let newFilteredData = [...data]

    const getNestedProperty = ( obj, keys ) => {
        return keys.reduce( ( acc, key ) => acc && acc[key], obj )
    }

    const keys = property?.split( '.' )
    newFilteredData.sort( ( a, b ) => {
        const aval = getNestedProperty( a, keys )
        const bval = getNestedProperty( b, keys )

        if ( type === 'number' ) {
            if ( order === '1' ) {
                return parseInt( aval ) - parseInt( bval )
            } else {
                return parseInt( bval ) - parseInt( aval )
            }
        } else {
            if ( order === '1' ) {
                return aval?.localeCompare( bval, undefined, { sensitivity: 'base' } )
            } else {
                return bval?.localeCompare( aval, undefined, { sensitivity: 'base' } )
            }
        }
    } )
    setData( newFilteredData )
}

/**
 * Sorts an array of objects by a specific key using a custom weight mapping.
 * 
 * @param {Array<Object>} arr - The array of objects to sort.
 * @param {string} key - The object property containing the enum values.
 * @param {Object<string, number>} weightMap - Mapping of enum values to numeric weights.
 * @param {number} [defaultWeight=Infinity] - Weight for values not found in the map.
 * @param {boolean} [ascending=true] - True for ascending order, false for descending.
 * @returns {Array<Object>} A new sorted array.
 */
export const sortByEnumWeight = ( arr, key, weightMap, ascending = true, defaultWeight = Infinity ) => {
    return [...arr].sort( ( a, b ) => {
        const weightA = weightMap[a[key]] !== undefined ? weightMap[a[key]] : defaultWeight
        const weightB = weightMap[b[key]] !== undefined ? weightMap[b[key]] : defaultWeight

        return ascending ? weightA - weightB : weightB - weightA
    } )
}

export const isIOS = () => {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes( window.navigator?.userAgentData?.platform ) || ( navigator.userAgent.includes( 'Mac' ) && 'ontouchend' in document )
}

export const time24to12 = ( time ) => {
    try {
        if ( time ) {
            const formatedTime = new Date( `2024-01-01 ${time}` ).toLocaleTimeString( 'en-IN', { hour: '2-digit', minute: '2-digit' } )
            if ( formatedTime !== 'Invalid Date' ) return formatedTime.toUpperCase()
            else return ''
        } else return ''
    } catch ( err ) {
        console.log( 'ERROR', err )
        return time
    }
}

export const isUrlAccessible = async ( url, timeoutMs = 4000 ) => {
    if ( !url ) return false

    const controller = new AbortController()
    const timer = setTimeout( () => controller.abort(), timeoutMs )

    try {
        const res = await fetch( url, { method: 'HEAD', signal: controller.signal, cache: 'no-store' } )
        return res.ok
    } catch {
        return false // network error, CORS block, or timeout
    } finally {
        clearTimeout( timer )
    }
}